import * as Yup from 'yup';
import { DB_PREFIX_REFERENCES, DB_PREFIX_REFEREES } from './constants';

export default Yup.object().shape({
  [DB_PREFIX_REFERENCES]: Yup.array().of(
    Yup.object().shape({
      fileURL: Yup.string().required('Required').nullable(),
    })
  ),

  [DB_PREFIX_REFEREES]: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Required').nullable(),
      role: Yup.string().required('Required').nullable(),
      organisation: Yup.string().required('Required').nullable(),
      telephone: Yup.string().required('Required').nullable(),
      email: Yup.string().required('Required').nullable(),
    })
  ),
});
